import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  TextField,
} from "@mui/material";
import { ChangeEvent, MouseEvent, useCallback, useState } from "react";
import {
  IBranchHierarchyEmployeeDto,
  IBranchHierarchyRegionDto,
} from "../../@types/branchDivision";
import { useBranchDivisionContext } from "../../Context/BranchDivisionContext";
import { StyledButton } from "../../Components/ui/CustomButton";
import {
  createBranchDivision,
  updateBranchDivision,
} from "../../Services/branchDivisionService";

function BranchDivisionDialog(props: any): JSX.Element {
  const branchDivisionContext = useBranchDivisionContext();
  const [error, setErrorText] = useState("");
  const branchRegions = branchDivisionContext?.branchRegions;
  const employees = branchDivisionContext?.employees;
  const open = branchDivisionContext?.open ?? false;
  const branchDivisionDto = branchDivisionContext?.branchDivisionDto;
  const selectedDivisionId = branchDivisionContext?.selectedDivisionId;
  const selectedRegionId = branchDivisionContext?.selectedRegionId;
  const selectedEmployeeId = branchDivisionContext?.selectedEmployeeId;
  const selectedTitle = branchDivisionContext?.selectedTitle;

    const handleSubmit = useCallback(async (event: MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      if (!selectedTitle || !selectedEmployeeId || !selectedRegionId) {
            setErrorText("Please select a value")
        }
        else {
            setErrorText("")
            if (!branchDivisionDto?.branchDivisionId) {
            await createBranchDivision(branchDivisionDto);
            }
            else {
            await updateBranchDivision(branchDivisionDto);
          }
            branchDivisionContext?.setOpen(false)
          await branchDivisionContext?.load();
        }

    }, [branchDivisionDto, branchDivisionContext, selectedEmployeeId, selectedRegionId, selectedTitle]);

    const handleDelete = useCallback(async (event: MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      branchDivisionDto!.isActive = false;
      await updateBranchDivision(branchDivisionDto);
      branchDivisionContext?.setOpen(false)
      await branchDivisionContext?.load();
    }, [branchDivisionDto, branchDivisionContext, selectedEmployeeId, selectedRegionId, selectedTitle]);

  const handleRegion = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    branchDivisionContext?.setSelectedRegionId(event.target.value);
    branchDivisionContext?.setBranchDivisionDto({
      ...branchDivisionDto,
      [name]: value,
    });
  };

  const handleTitleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    branchDivisionContext?.setSelectedTitle(event.target.value);
    branchDivisionContext?.setBranchDivisionDto({
      ...branchDivisionDto,
      [name]: value,
    });
  };

  const handleEmployee = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
      const { name, value } = event.target;
      branchDivisionContext?.setSelectedEmployeeId(value);
      const selectedEmployee = employees?.find(
          (employee) => employee.employeeGuid === value
      );
      branchDivisionContext?.setBranchDivisionDto({
      ...branchDivisionDto,
          [name]: value,
          managerEmployeeId: selectedEmployee?.employeeId ?? 0,
    });
  };

  return (
    <>
      <Dialog open={open} onClose={props.close}>
        <DialogTitle>Division - Save and Edit</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Box
              component="form"
                            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
              noValidate
              autoComplete="off"
            >
              <div>
                <TextField
                  disabled={true}
                  value={selectedDivisionId}
                  id="outlined-basic"
                  name="branchDivisionId"
                                    placeholder='Branch Division Id'
                  label="Division ID"
                                    variant="outlined" />
                <TextField
                  error={!selectedTitle}
                  helperText={!selectedTitle ? error : ""}
                  onChange={handleTitleChange}
                  value={selectedTitle}
                  required
                  id="outlined-basic"
                  name="title"
                                    placeholder='Title'
                  label="Title"
                                    variant="outlined" />
                <TextField
                  id="outlined-select-Region"
                  select
                  required
                  name="branchRegionId"
                  label="Select Region"
                  error={!selectedRegionId}
                  helperText={!selectedRegionId ? error : ""}
                  value={selectedRegionId}
                  onChange={handleRegion}
                >
                  {branchRegions &&
                    branchRegions.map((region: IBranchHierarchyRegionDto) => (
                      <MenuItem
                        key={region.title}
                        value={region.branchRegionId}
                      >
                        {region.title}
                      </MenuItem>
                    ))}
                </TextField>
                <TextField
                  id="outlined-select-Employee"
                  select
                  required
                  name="managerEmployeeGuid"
                  label="Select Employee"
                  error={!selectedEmployeeId}
                  helperText={!selectedEmployeeId ? error : ""}
                  value={selectedEmployeeId}
                  onChange={handleEmployee}
                >
                  {employees &&
                    employees.map((employee: IBranchHierarchyEmployeeDto) => (
                      <MenuItem
                        key={employee.employeeGuid}
                        value={employee.employeeGuid}
                      >
                        {employee.name}
                      </MenuItem>
                    ))}
                </TextField>
              </div>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: "flex" }}>
            <StyledButton
              onClick={handleDelete}
              style={{ background: "#FF0000", marginRight: "auto" }}
            >
              Delete
            </StyledButton>
          <StyledButton onClick={handleSubmit}>Submit</StyledButton>
          <StyledButton onClick={props.close}>Cancel</StyledButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default BranchDivisionDialog;
